/**
 * Reads an image's labelling from the BE: the AI description (details) and OCR text. Trivial images
 * have neither. Field names are assumed — staging doesn't send them yet — so missing or blank
 * values mean "no labelling".
 */
export interface ImageLabelling {
  /** The model's description of the picture, shown as the image's details. */
  caption?: string;
  /** Text read out of the picture. Markdown, as the model returned it. */
  ocrText?: string;
}

const readNonEmptyString = (source: Record<string, unknown>, key: string): string | undefined => {
  const value = source[key];
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed || undefined;
};

/** Image labelling from a preview response, or `undefined` when there is none. */
export const parseImageLabelling = (source: unknown): ImageLabelling | undefined => {
  if (!source || typeof source !== 'object') return undefined;

  const record = source as Record<string, unknown>;
  const caption = readNonEmptyString(record, 'caption');
  const ocrText = readNonEmptyString(record, 'ocrText');

  if (!caption && !ocrText) return undefined;
  return { caption, ocrText };
};
